import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormQualification } from './types';

export const transformDataset = (values: FiltersFormQualification): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codiceQualifica: {
      value: otherValues.code,
      operation: Operation.LIKE,
    },
    descrizione: {
      value: otherValues.description,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codiceQualifica: ordersToTransform.code,
    descrizione: ordersToTransform.description,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
